export default (function (_ref) {
  var request = _ref.request;
  return {
    marketSpecPriceAdd: function marketSpecPriceAdd(data) {
      return request({
        url: '/mng/marketSpecPrice/add',
        method: 'post',
        data: data
      });
    },
    marketSpecPriceModify: function marketSpecPriceModify(data) {
      return request({
        url: "/mng/marketSpecPrice/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    marketSpecPriceDel: function marketSpecPriceDel(id) {
      return request({
        url: "/mng/marketSpecPrice/".concat(id, "/del"),
        method: 'delete'
      });
    },
    marketSpecPriceQuery: function marketSpecPriceQuery(data) {
      return request({
        url: '/mng/marketSpecPrice/query',
        method: 'get',
        params: data
      });
    },
    marketSpecPriceDetail: function marketSpecPriceDetail(id) {
      return request({
        url: "/mng/marketSpecPrice/".concat(id, "/detail"),
        method: 'get'
      });
    }
  };
});